

(function () {

    angular.module('tmx-common').directive('tmxBarchart', tmxBarchart);

    function tmxBarchart() {

        return {
            scope: {
                data: "=",
                field: "@",
                dir: "@",
                type: "@",
                series: "=",
                title: "@",
                categories: "=",
                stack: "=",
                onSeriesClick: '&?',
                filter: '=?',
                seriesColors: '=?',
                labelDirection: '@?'
            },
            require: 'ngModel',
            restrict: 'E',
            templateUrl: 'common/directives/tmxbarchart/tmxbarchart.html',
            controller: tmxBarchartCtrl,
            controllerAs: 'BarChartCtrl'

        }
    }
    function tmxBarchartCtrl($scope, $rootScope, APP_CONSTANTS) {
        $scope.onSeriesHover = function (e) {
            kendoConsole.log(kendo.format("event :: seriesHover ({0} : {1})", e.series.name, e.value));
        };

        var tmxBarchartVM = this;
        var labelRotation = 0;
        tmxBarchartVM.series = $scope.series;
        tmxBarchartVM.seriesColors = $scope.seriesColors;
        tmxBarchartVM.title = $scope.title;
        tmxBarchartVM.categories = $scope.categories;
        tmxBarchartVM.type = $scope.type;
        tmxBarchartVM.stack = $scope.stack;
        tmxBarchartVM.tooltip = "{ visible: 'true', template: '#= series.name #' }"
        if ($scope.labelDirection) {
            labelRotation = $scope.labelDirection.toLowerCase() == "diagonal" ? -45 : $scope.labelDirection.toLowerCase() == "vertical" ? -90 : 0;
        }
        tmxBarchartVM.filter = $scope.filter;
        tmxBarchartVM.filterChanged = function (selectedValue) {
            if (selectedValue) {
                tmxBarchartVM.electricity.options.transport.read.url = getDataUrl(selectedValue);
                tmxBarchartVM.electricity.read();
            }
        }
        tmxBarchartVM.electricity = new kendo.data.DataSource({
            transport: {
                read: {
                    url: tmxBarchartVM.filter ? getDataUrl(tmxBarchartVM.filter.selectedValue) : getDataUrl(),
                    dataType: "json",
                    beforeSend: function (req) {
                        req.setRequestHeader('Offset', 100);
                    }
                }
            },
            sort: {
                field: $scope.field,
                dir: $scope.dir
            }
        });


        tmxBarchartVM.chartOptions = /* chart data*/
        {
            // "title": {
            //     "text": tmxBarchartVM.title,
            //     "position": "bottom",
            //     "align": "center"
            // },
            "legend": {
                "visible": true,
                "position": "bottom"

            },
            "seriesDefaults": {
                "type": tmxBarchartVM.type, //value are 'column' or 'bar'
                "stack": tmxBarchartVM.stack // for stacked version of bar graph
            },
            "valuesAxis":
            {

                "line": {
                    "visible": false
                }
            },
            "categoryAxis": {
                "labels": {
                    "rotation": labelRotation
                }
            },
            "pannable": {
                "lock": "y"
            },
            // "zoomable": {
            //     "mousewheel": {
            //         "lock": "y"
            //     },
            //     "selection": {
            //         "lock": "y"
            //     }
            // },
            "series": tmxBarchartVM.series,
            "seriesColors": tmxBarchartVM.seriesColors,
            "dataSource": tmxBarchartVM.electricity,
            "tooltip": {
                "visible": true,
                "template": "#= series.name #: #= value #"
            },
            "chartArea":
            {
                "background": "	#FFFFFF"
            },
            "seriesClick": onSeriesClick,
        }

        function onSeriesClick(e) {
            if (angular.isFunction($scope.onSeriesClick)) {
                var data = e.sender.dataSource.data().at(e.series.index);
                $scope.onSeriesClick()(e, data);
            }
        }
        function getDataUrl(selectedValue) {
            if (tmxBarchartVM.filter && tmxBarchartVM.filter.show) {
                return APP_CONSTANTS.backend + $scope.data + "/" + selectedValue;
            }
            return APP_CONSTANTS.backend + $scope.data
        }

    }

})();